// assets/cart-weight-popover.js
(function(){
  const el = document.getElementById('cp-popover');
  if(!el) return;

  async function getCart(){
    const r = await fetch('/cart.js', {credentials:'same-origin'});
    if(!r.ok) throw new Error('cart fetch');
    return r.json();
  }

  async function sync(){
    try{
      const cart = await getCart();
      // show only if there are items
      el.style.display = cart.item_count > 0 ? '' : 'none';
      // Close if it was open and cart became empty
      if(cart.item_count === 0 && el.hasAttribute('open')) el.removeAttribute('open');
    }catch(e){
      // keep silent
    }
  }

  // initial + keep in sync with Dawn events
  sync();
  document.addEventListener('cart:refresh', sync);
  document.addEventListener('ajaxProduct:added', sync);
  document.addEventListener('cart:updated', sync);

  // gentle polling fallback (covers 3rd-party apps)
  setInterval(sync, 6000);
})();
